// This can become an actual panel for the Admin under some Settings section and enable them to switch on / off pre-release features
// this needs to turn into hook, and get initialised , get the match from props, and based on the url or pre-defined values here

export const FT_ENABLE_RANDOM_REPORTING_STATS =
  import.meta.env.VITE_FEATURE_RANDOM_REPORTING_STATS === "true" &&
  import.meta.env.VITE_ENVIRONMENT !== "production";
export const FT_ENABLE_SMB = import.meta.env.VITE_FEATURE_SMB === "true";
export const FT_ENABLE_INBOX_MESSAGES =
  import.meta.env.VITE_FEATURE_INBOX_MESSAGES === "true";
export const FT_ENABLE_NOTIFICATION =
  import.meta.env.VITE_FEATURE_NOTIFICATION_ICON === "true";
export const FT_SUPER_ADMIN_MONITORING =
  import.meta.env.VITE_FEATURE_SUPER_ADMIN_MONITORING === "true";
export const FT_ENABLE_ADMIN_SIGNUP =
  import.meta.env.VITE_FEATURE_ADMIN_SIGNUP === "true";
export const FRONT_END_DEBUG = import.meta.env.VITE_FRONTEND_DEBUG === "true";
export const FT_ENABLE_SAFE_WORDS =
  import.meta.env.VITE_FEATURE_SAFE_WORD === "true";
export const FT_ENABLE_DLR_LOOKUP =
  import.meta.env.VITE_FEATURE_DLR_LOOKUP === "true";
export const FT_REACT_APP_TAX_RATE = import.meta.env.VITE_TAX_RATE;
export const FT_REACT_APP_ENABLE_CURRENCY_SELECTION =
  import.meta.env.VITE_ENABLE_CURRENCY_SELECTION === "true";
export const FT_REACT_APP_MODE = import.meta.env.VITE_MODE;
export const FT_REACT_APP_FEATURE_ADMIN_FORGOT_PASSWORD =
  import.meta.env.VITE_FEATURE_ADMIN_FORGOT_PASSWORD === "true";
export const FT_REACT_APP_FEATURE_TEMPLATE_MANAGER =
  import.meta.env.VITE_FEATURE_TEMPLATE_MANAGER === "true";
export const FT_ENABLE_TRANSACTION_REPORT =
  import.meta.env.VITE_FEATURE_TRANSACTION_REPORT === "true";
export const FT_ENABLE_ITEMIZATION_REPORT =
  import.meta.env.VITE_FEATURE_ITEMIZATION_REPORT === "true";
export const FT_ENABLE_CONFIRM_API =
  import.meta.env.VITE_FEATURE_CONFIRM_API === "true";
export const FT_HIDE_REPORT_SUMMARY =
  import.meta.env.VITE_HIDE_REPORT_SUMMARY === "true";
export const FT_ENABLE_GENERATE_REPORT_ADMIN =
  import.meta.env.VITE_FEATURE_GENERATE_REPORT_ADMIN === "true";
export const FT_ENABLE_GENERATE_REPORT_USER =
  import.meta.env.VITE_FEATURE_GENERATE_REPORT_USER === "true";
export const FT_ENABLE_GENERATE_REPORT_RESELLER =
  import.meta.env.VITE_FEATURE_GENERATE_REPORT_RESELLER === "true";
export const FT_ENABLE_MESSAGE_API_ADMIN =
  import.meta.env.VITE_FEATURE_MESSAGE_API_ADMIN === "true";
export const FT_ENABLE_MESSAGE_API_USER =
  import.meta.env.VITE_FEATURE_MESSAGE_API_USER === false;
export const FT_ENABLE_MESSAGE_API_RESELLER =
  import.meta.env.VITE_FEATURE_MESSAGE_API_RESELLER === "true";
export const FT_ENABLE_SEND_OTT_MESSAGE = 
  import.meta.env.VITE_FEATURE_SEND_OTT_MESSAGE === "true";
export const FT_ENABLE_ZIP_COMPRESSION = 
  import.meta.env.VITE_FEATURE_ZIP_COMPRESSION === "true";
export const FT_ENABLE_CLICK_ANALYSIS = 
  import.meta.env.VITE_FEATURE_CLICK_ANALYSIS === "true";
